import { View, Text, styled } from 'tamagui'
import { Avatar, Badge } from '../../common'
import type { DirectMessageChannel, User } from '@/types'

const Item = styled(View, {
  flexDirection: 'row',
  alignItems: 'center',
  height: 44,
  paddingHorizontal: 12,
  marginHorizontal: 8,
  borderRadius: '$borderRadiusMd',
  gap: 10,
  cursor: 'pointer',
  hoverStyle: {
    backgroundColor: '$sidebarHover',
  },
  // @ts-expect-error -- web transition
  style: { transition: 'background-color 150ms ease' },
  variants: {
    active: {
      true: {
        backgroundColor: '$sidebarActive',
      },
    },
  } as const,
})

const Info = styled(View, { flex: 1, gap: 1 })

const Name = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 14,
  fontWeight: '500',
  color: '$surfaceForeground',
})

const Preview = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 12,
  color: '$sidebarMuted',
})

function formatTime(ts: number): string {
  const diff = Date.now() - ts
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m`
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h`
  return `${Math.floor(diff / 86400000)}d`
}

interface DMConversationItemProps {
  dm: DirectMessageChannel
  user: User
  isActive: boolean
  onPress: () => void
}

export function DMConversationItem({ dm, user, isActive, onPress }: DMConversationItemProps) {
  return (
    <Item active={isActive} onPress={onPress}>
      <Avatar name={user.displayName} color={user.roleColor || '#8B95A8'} status={user.status} size="md" />
      <Info>
        <View flexDirection="row" alignItems="center" gap={6}>
          <Name
            fontWeight={dm.unreadCount > 0 ? '600' : '500'}
            flex={1}
            numberOfLines={1}
          >
            {user.displayName}
          </Name>
          <Text fontFamily="$fontBody" fontSize={10} color="$color8">{formatTime(dm.lastMessageAt)}</Text>
        </View>
        <Preview numberOfLines={1}>{dm.lastMessagePreview}</Preview>
      </Info>
      {dm.unreadCount > 0 && <Badge count={dm.unreadCount} variant="mention" />}
    </Item>
  )
}
